module.exports = __webpack_public_path__ + "static/media/logo1yomi.95064fbe.png";